import { InjectionToken } from '@angular/core';

export const CASTING_HUB_URL = new InjectionToken<string>('CASTING_HUB_URL');
